import { format } from 'date-fns';
import { formatLeadsByMedium } from 'lib/reportingUtils';
import mapKeys from '../lib/mapKeys.js';

export const crm_inquiries_middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (action.type === 'CRM_FETCH_LEAD_INQUIRIES_SUCCESS') {
      action.payload.formattedLeads = action.payload.leads
        .sort((a, b) => {
          let aDate = new Date(a.date_created);
          let bDate = new Date(b.date_created);
          return bDate - aDate;
        })
        .map((lead) => {
          return {
            id: { value: lead.lead_id },
            'lead type': { value: lead.lead_type, meta: lead.lead_meta },
            source: { value: lead.lead_source },
            'phone name': { value: lead.phone_name },
            'tracking number': { value: lead.tracking_number },
            medium: { value: lead.lead_medium },
            date: { value: format(new Date(lead.date_created), 'MMM do h:mm a') },
          };
        });

      action.payload.leadsById = mapKeys(action.payload.leads, 'lead_id');
    }
    if (action.type === 'CRM_FETCH_LEAD_INQUIRIES_ANALYTICS_SUCCESS') {
      action.payload = formatLeadsByMedium(action.payload);
    }
    next(action);
  };
